import React from "react";
import {Text, Box} from "@unibuddy/patron";
import {IconPaperAirplane} from "@unibuddy/icons";
import styled from "styled-components";

type QuestionsPromptPopUpQuestionProps = {
    question: string;
    onQuestionSelect: (question: string) => void;
};

const StyledButton = styled.button`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border: 1px solid ${({theme}) => theme.colors.grey150};
    border-radius: 8px;
    background-color: white;
    padding: 12px;

    &:hover {
        background-color: ${({theme}) => theme.colors.grey100};
    }

    &:active {
        background-color: ${({theme}) => theme.colors.grey200};
    }
`;

export function QuestionsPromptPopUpQuestion({
    question,
    onQuestionSelect,
}: QuestionsPromptPopUpQuestionProps) {
    return (
        <StyledButton
            onClick={() => {
                onQuestionSelect(question);
            }}
        >
            <Text style={{wordWrap: "break-word", overflowWrap: "break-word"}} size="small">
                {question}
            </Text>{" "}
            <Box flexShrink={0} marginLeft="xxsmall">
                <IconPaperAirplane />
            </Box>
        </StyledButton>
    );
}
